<ng-container *ngIf="sourceLanguage$ | async"></ng-container>

<div class="translate-update">
  <h6>Update Source Translations</h6>

  <div class="translate-update-field-container">
    <label class="translate-update-field-container-title">Operation</label>
    <nb-form-field>
      <nb-select
        [(ngModel)]="selectedOperation"
        placeholder="Action"
        [fullWidth]="true"
      >
        <nb-option value="add">Add Key</nb-option>
        <nb-option value="update">Update Key</nb-option>
      </nb-select>
    </nb-form-field>
  </div>

  <div
    *ngIf="selectedOperation === 'update'"
    class="translate-update-field-container"
  >
    <div class="translate-update-field-content">
      <nb-form-field>
        <label>Select Key</label>
        <nb-select
          [(ngModel)]="selectedKey"
          placeholder="Translation Key"
          [fullWidth]="true"
          (ngModelChange)="updateSelectedKeyValue()"
        >
          <nb-option *ngFor="let option of keys" [value]="option">{{
            option
          }}</nb-option>
        </nb-select>
      </nb-form-field>

      <div *ngIf="selectedKey">
        <nb-form-field>
          <label>Source Text</label>
          <input [fullWidth]="true" nbInput [(ngModel)]="selectedKeyValue" />
        </nb-form-field>
      </div>

      <div class="translate-update-action-btn-container">
        <button
          nbButton
          [disabled]="
            isUpdating ||
            !selectedKey ||
            selectedKeyValue === translation[selectedKey]
          "
          status="primary"
          (click)="updateKey()"
        >
          <ng-container *ngIf="isUpdating">
            <span style="padding-right: 8px"
              ><i class="fas fa-spinner fa-spin"></i
            ></span>
          </ng-container>
          Update
        </button>
      </div>
    </div>
  </div>
  <div
    *ngIf="selectedOperation === 'add'"
    class="translate-update-field-container"
  >
    <nb-form-field>
      <label>New Key</label>
      <input
        placeholder="New Key"
        [fullWidth]="true"
        nbInput
        [(ngModel)]="newKey"
      />
    </nb-form-field>
    <nb-form-field>
      <label>Source Text</label>
      <input
        placeholder="Text Content"
        [fullWidth]="true"
        nbInput
        [(ngModel)]="newContent"
      />
    </nb-form-field>

    <div class="translate-update-action-btn-container">
      <button
        (click)="addKey()"
        nbButton
        [disabled]="
          isUpdating ||
          !newKey ||
          !newContent ||
          translation?.hasOwnProperty(newKey)
        "
        status="primary"
      >
        <ng-container *ngIf="isUpdating">
          <span style="padding-right: 8px"
            ><i class="fas fa-spinner fa-spin"></i
          ></span>
        </ng-container>
        Add
      </button>
    </div>
  </div>
</div>
